// extracted by mini-css-extract-plugin
export default {"clear":"InputSelect_clear--_hC","s":"InputSelect_s--ULL","right":"InputSelect_right--gag","m":"InputSelect_m--vWB"};